<!-- 自定义radio option --->
<template>
<el-radio 
    class="team-win"
    v-bind="$attrs"
    v-on="$listeners"
>
<slot >
    
</slot>
</el-radio>
</template>
<script>
export default {
    name:'BallRadio'
}
</script>
<style lang="less" scoped>
.team-win{
    border:2px solid #ccc; border-radius: 3px; padding: 10px 15px; box-sizing: border-box; background: #fff;
    /deep/.el-radio__input{display: none;}
    /deep/.el-radio__label{font-size: 14px; line-height: 20px;padding-left: 0; }
    &.is-checked{
        border-color: #FF4E14;
        /deep/.el-radio__label{color: #FF4E14;}
        &:after{
            content:''; position: absolute; right: -1px; bottom: -1px; background: url(../assets/checked-small.png) no-repeat right bottom; background-size: 100%; width:22px; height: 17px;
        }
    }
    &.gold{padding-left: 0; padding-right: 0;}
}
</style>